export default "__VITE_ASSET__DUJOY2f1__"